/**
 * Created by aguerrero on 03/04/2016.
 */

angular
    .module('annexaApp')
    .controller('CommonEntitiesController', ['$scope', '$rootScope', 'CommonAdminModals', 'AnnexaFormlyFactory', 'RestService', 'AnnexaModalFactory', 'Language', '$filter', 'GlobalDataFactory', 'CacheFactory', function($scope, $rootScope, CommonAdminModals, AnnexaFormlyFactory, RestService, AnnexaModalFactory, Language, $filter, GlobalDataFactory, CacheFactory) {
    	$scope.languageColumn = Language.getActiveColumn();
    	
    	$scope.filter = [
			{ id: Language.getActiveColumn(), type: 'text', order: 1, label: 'global.literals.name' }
        ];
		
        $scope.additionalColumns = [
        	{ id: 'urlBase', title: $filter('translate')('global.literals.urlBase')}
        ]
        $scope.reloadTable = function(){
        	$rootScope.$broadcast('annexaAdminBaseReloadTable');
        }
        $scope.newElement = function() {
            var modal = angular.copy(CommonAdminModals.commonEntityNew);
            modal.annexaFormly.model = {};
            modal.annexaFormly.model.modal_body = {};
            modal.annexaFormly.options = {};

            AnnexaFormlyFactory.showModal('modalNewCommonEntity', modal, $scope.saveCommonEntity, false);
        }

        $scope.viewElement = function (id) {
            RestService.findOne('CommonEntity', id).then(function(data) {
                var decodeddata = JSOG.decode(data.data);

                var modal = CommonAdminModals.commonEntityEdit;
                modal.alerts = [];
                modal.data = decodeddata;
                modal.languageColumn = $scope.languageColumn;

                modal.updateCommonEntity = $scope.updateCommonEntity;

                AnnexaModalFactory.showModal('modalCommonEntityEdit', modal);
            });
        }

        $scope.saveCommonEntity = function (commonEntity) {
            var modal = this;

            var model = {
                language1: commonEntity.annexaFormly.model.modal_body.language1,
                language2: commonEntity.annexaFormly.model.modal_body.language2 ? commonEntity.annexaFormly.model.modal_body.language2 : 'NotTranslated',
                language3: commonEntity.annexaFormly.model.modal_body.language3 ? commonEntity.annexaFormly.model.modal_body.language3 : 'NotTranslated',
                urlBase: commonEntity.annexaFormly.model.modal_body.urlBase
            }

            RestService.insert('./api/common_entity', model)
                .then(function () {
                	$scope.reloadTable();
                    if(GlobalDataFactory.commonEntities){
                    	GlobalDataFactory.commonEntities.length = 0;
                    }else{
                    	GlobalDataFactory.commonEntities = [];
                    }
                    if(CacheFactory.get('globalDataCache') && CacheFactory.get('globalDataCache').get('CommonEntity')){
                    	CacheFactory.get('globalDataCache').remove('CommonEntity');
                    }
                    GlobalDataFactory.loadGlobalData();
                    modal.close();
                }).catch(function () {
                    modal.alerts.push({ msg: $filter('translate')('global.errors.unknownNew') })
            })
        }

        $scope.updateCommonEntity = function(val, prop) {
            var model = angular.copy(this.data);

            if (prop == 'urlBase') {
                model[prop] = val;
            } else {
                model = val;
            }
            
            RestService.update('./api/common_entity/' + model.id, model)
                .then(function (data) {
                	$scope.reloadTable();
                    if(GlobalDataFactory.commonEntities){
                    	GlobalDataFactory.commonEntities.length = 0;
                    }else{
                    	GlobalDataFactory.commonEntities = [];
                    }
                    if(CacheFactory.get('globalDataCache') && CacheFactory.get('globalDataCache').get('CommonEntity')){
                    	CacheFactory.get('globalDataCache').remove('CommonEntity');
                    }
                    GlobalDataFactory.loadGlobalData();
                }).catch(function () {
                    //Empty
            });
        }
    }]);
